var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5108 92.8125H24.3233V83.5312H11.9483V92.8125H5.7608V83.5312C5.76244 81.8907 6.41486 80.3179 7.57489 79.1578C8.73492 77.9978 10.3078 77.3454 11.9483 77.3438H24.3233C25.9638 77.3454 27.5367 77.9978 28.6967 79.1578C29.8567 80.3179 30.5092 81.8907 30.5108 83.5312V92.8125ZM92.3858 92.8125H86.1983V83.5312H73.8233V92.8125H67.6358V83.5312C67.6374 81.8907 68.2899 80.3179 69.4499 79.1578C70.6099 77.9978 72.1828 77.3454 73.8233 77.3438H86.1983C87.8388 77.3454 89.4117 77.9978 90.5717 79.1578C91.7317 80.3179 92.3842 81.8907 92.3858 83.5312V92.8125ZM61.4483 92.8125H55.2608V83.5312H42.8858V92.8125H36.6983V83.5312C36.6999 81.8907 37.3524 80.3179 38.5124 79.1578C39.6724 77.9978 41.2453 77.3454 42.8858 77.3438H55.2608C56.9013 77.3454 58.4742 77.9978 59.6342 79.1578C60.7942 80.3179 61.4467 81.8907 61.4483 83.5312V92.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0733 74.25C52.4906 74.25 55.2608 71.4798 55.2608 68.0625C55.2608 64.6452 52.4906 61.875 49.0733 61.875C45.656 61.875 42.8858 64.6452 42.8858 68.0625C42.8858 71.4798 45.656 74.25 49.0733 74.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1358 74.25C21.5531 74.25 24.3233 71.4798 24.3233 68.0625C24.3233 64.6452 21.5531 61.875 18.1358 61.875C14.7185 61.875 11.9483 64.6452 11.9483 68.0625C11.9483 71.4798 14.7185 74.25 18.1358 74.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0108 74.25C83.4281 74.25 86.1983 71.4798 86.1983 68.0625C86.1983 64.6452 83.4281 61.875 80.0108 61.875C76.5935 61.875 73.8233 64.6452 73.8233 68.0625C73.8233 71.4798 76.5935 74.25 80.0108 74.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5421 61.875C67.9593 61.875 70.7296 59.1048 70.7296 55.6875C70.7296 52.2702 67.9593 49.5 64.5421 49.5C61.1248 49.5 58.3546 52.2702 58.3546 55.6875C58.3546 59.1048 61.1248 61.875 64.5421 61.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6046 61.875C37.0218 61.875 39.7921 59.1048 39.7921 55.6875C39.7921 52.2702 37.0218 49.5 33.6046 49.5C30.1873 49.5 27.4171 52.2702 27.4171 55.6875C27.4171 59.1048 30.1873 61.875 33.6046 61.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0108 43.3125H18.1358C16.4953 43.3109 14.9224 42.6584 13.7624 41.4984C12.6024 40.3384 11.9499 38.7655 11.9483 37.125V12.375C11.9499 10.7345 12.6024 9.16161 13.7624 8.00159C14.9224 6.84156 16.4953 6.18914 18.1358 6.1875H80.0108C81.6513 6.18914 83.2242 6.84156 84.3842 8.00159C85.5442 9.16161 86.1967 10.7345 86.1983 12.375V37.125C86.1967 38.7655 85.5442 40.3384 84.3842 41.4984C83.2242 42.6584 81.6513 43.3109 80.0108 43.3125ZM18.1358 12.375V37.125H80.0108V12.375H18.1358Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionsIcon);
export default __webpack_public_path__ + "static/media/sessionsIcon.c7489bf778ee80a3b6df0275be31b740.svg";
export { ForwardRef as ReactComponent };